import React from 'react';
import PropTypes from 'prop-types';
import Typography from '../Typography';
import { StyledImage, StyledWhatsAppShareButton } from './styles';
import ICON_WHATSAPP from './assets/icon-whatsapp.png';

/**
 * Facebook Share Button Component
 * @param {{
 * icon: string,
 * onClick: () => void,
 * wrapperClassName: string,
 * logoStyle: React.CSSProperties,
 * textColor: string,
 * height: string | number
 * } & import('../styled-system').SizingProps & import('../styled-system').ColorProps} props
 * @returns
 * @example
 * <WhatsappShareButton onClick={() => {}}/>
 */
const WhatsappShareButton = ({
  icon,
  onClick,
  wrapperClassName,
  logoStyle,
  textColor,
  ...props
}) => (
  <div className={wrapperClassName}>
    <StyledWhatsAppShareButton
      role="button"
      onClick={onClick}
      data-testid="whatsapp-share-button__wrapper"
      {...props}
    >
      <StyledImage
        src={icon}
        alt="facebook-icon"
        style={logoStyle}
        data-testid="whatsapp-share-button__image"
      />
      <Typography
        as="span"
        bold
        color={textColor}
        style={{ marginTop: 0 }}
        data-testid="whatsapp-share-button__text"
      >
        Bagikan Lewat Whatsapp
      </Typography>
    </StyledWhatsAppShareButton>
  </div>
);

export default WhatsappShareButton;

WhatsappShareButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  wrapperClassName: PropTypes.string,
  logoStyle: PropTypes.object,
  textColor: PropTypes.string,
  icon: PropTypes.string.isRequired,
  height: PropTypes.number,
};

WhatsappShareButton.defaultProps = {
  icon: ICON_WHATSAPP,
  wrapperClassName: '',
  logoStyle: {},
  textColor: 'white',
  height: 40,
};
